import React, { useState, useEffect } from 'react';
import { FormikProvider, FieldArray } from 'formik';
import {
  Box,
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import OrderFileMultiFileForm from './OrderFileMultiFileForm';

import 'dayjs/locale/ko'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


const OrderBookForm = ({ type, orderInfo, chance, formik }) => {
  const [siDt, setSiDt] = useState(null);
  const [expDay, setExpDay] = useState(null);
  const [mtnFreeStrtDt, setMtnFreeStrtDt] = useState(null);
  const [mtnFreeEndDt, setMtnFreeEndDt] = useState(null);

  const [licStrtDt, setLicStrtDt] = useState(null);
  const [licEndDt, setLicEndDt] = useState(null);

  const [dlvryDuedate, setDlvryDuedate] = useState(null);
  
  // const [giPrePct, setGiPrePct] = useState(null);
  // const [giGovPct, setGiGovPct] = useState(null);
  // const [giMtnPct, setGiMtnPct] = useState(null);

  
  // giPrePct: values.giPrePct, //보증보험(선급금 비율율)
  // giGovPct: values.giGovPct, //보증보험(계약이행 비율)
  // giMtnPct: values.giMtnPct, //보증보험(하자유지보수 비율)


  useEffect(() => {

    if (orderInfo) {
      setSiDt(orderInfo.siDt);
      setExpDay(orderInfo.expDay);
      
      setMtnFreeStrtDt(orderInfo.mtnFreeStrtDt);
      setMtnFreeEndDt(orderInfo.mtnFreeEndDt);

      if( orderInfo.dlvryDuedate )setDlvryDuedate(orderInfo.dlvryDuedate);

      if( orderInfo.licStrtDt ) setLicStrtDt(orderInfo.licStrtDt);
      if( orderInfo.licEndDt ) setLicEndDt(orderInfo.licEndDt);
    }
  }, [orderInfo]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <>
      <Box sx={{ mt: 1, px: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              사업명
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {type === 'add' ? orderInfo?.cstNm : orderInfo?.prjNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출처
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.partnerNm}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={3}>
            <LocalizationProvider  dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="계약 시작일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="expDay"
                name="expDay"
                value={dayjs(expDay)}
                onChange={(newValue) => {
                  setExpDay(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'expDay');
                }}
                slotProps={{
                  textField: {
                    required: true,
                    fullWidth: true,
                    margin: "normal",
                    variant: "outlined",
                    error: formik.touched.expDay && Boolean(formik.errors.expDay),
                    helperText: formik.touched.expDay && formik.errors.expDay,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="계약 완료일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="siDt"
                name="siDt"
                value={dayjs(siDt)}
                onChange={(newValue) => {
                  setSiDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'siDt');
                }}
                slotProps={{
                  textField: {
                    required: true,
                    fullWidth: true,
                    margin: "normal",
                    variant: "outlined",
                    error: formik.touched.siDt && Boolean(formik.errors.siDt),
                    helperText: formik.touched.siDt && formik.errors.siDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          {chance?.prjTyp === 'N' && (
            <>
              <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko"
                >
                  <DatePicker
                    label="무상유지보수 시작일"
                    format="YYYY-MM-DD"
                    mask={'____-__-__'}
                    id="mtnFreeStrtDt"
                    name="mtnFreeStrtDt"
                    value={dayjs(mtnFreeStrtDt)}
                    onChange={(newValue) => {
                      setMtnFreeStrtDt(dayjs(newValue));
                      onChangeDate(dayjs(newValue), 'mtnFreeStrtDt');
                    }}
                    slotProps={{
                      textField: {
                        required: true,
                        fullWidth: true,
                        margin: "normal",
                        variant: "outlined",
                        error:
                          formik.touched.mtnFreeStrtDt &&
                          Boolean(formik.errors.mtnFreeStrtDt),
                        helperText:
                          formik.touched.mtnFreeStrtDt &&
                          formik.errors.mtnFreeStrtDt,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko"
                >
                  <DatePicker
                    label="무상유지보수 종료일"
                    format="YYYY-MM-DD"
                    mask={'____-__-__'}
                    id="mtnFreeEndDt"
                    name="mtnFreeEndDt"
                    value={dayjs(mtnFreeEndDt)}
                    onChange={(newValue) => {
                      setMtnFreeEndDt(dayjs(newValue));
                      onChangeDate(dayjs(newValue), 'mtnFreeEndDt');
                    }}
                    slotProps={{
                      textField: {
                        required: true,
                        fullWidth: true,
                        margin: "normal",
                        variant: "outlined",
                        error:
                          formik.touched.mtnFreeEndDt &&
                          Boolean(formik.errors.mtnFreeEndDt),
                        helperText:
                          formik.touched.mtnFreeEndDt &&
                          formik.errors.mtnFreeEndDt,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </>
          )}

          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="라이센스 시작일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="licStrtDt"
                name="licStrtDt"
                value={dayjs(licStrtDt)}
                onChange={(newValue) => {
                  setLicStrtDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'licStrtDt');
                }}
                slotProps={{
                  textField: {
                    required: true,
                    fullWidth: true,
                    margin: "normal",
                    variant: "outlined",
                    error: formik.touched.licStrtDt && Boolean(formik.errors.licStrtDt),
                    helperText: formik.touched.licStrtDt && formik.errors.licStrtDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="라이센스 만료일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="licEndDt"
                name="licEndDt"
                value={dayjs(licEndDt)}
                onChange={(newValue) => {
                  setLicEndDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'licEndDt');
                }}
                slotProps={{
                  textField: {
                    required: true,
                    fullWidth: true,
                    margin: "normal",
                    variant: "outlined",
                    error: formik.touched.licEndDt && Boolean(formik.errors.licEndDt),
                    helperText: formik.touched.licEndDt && formik.errors.licEndDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="납품 예정일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="dlvryDuedate"
                name="dlvryDuedate"
                value={dayjs(dlvryDuedate)}
                onChange={(newValue) => {
                  setLicStrtDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'dlvryDuedate');
                }}
                slotProps={{
                  textField: {
                    required: true,
                    fullWidth: true,
                    margin: "normal",
                    variant: "outlined",
                    error: formik.touched.dlvryDuedate && Boolean(formik.errors.dlvryDuedate),
                    helperText: formik.touched.dlvryDuedate && formik.errors.dlvryDuedate,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
          <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="inspectCond"
              name="inspectCond"
              label="검수 조건"
              value={formik.values.inspectCond}
              onChange={formik.handleChange}
              error={
                formik.touched.inspectCond && Boolean(formik.errors.inspectCond)
              }
              helperText={formik.touched.inspectCond && formik.errors.inspectCond}
            />
          </Grid>


          <Grid item xs={2}>
            <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="giPrePct"
              name="giPrePct"
              label="보증보험(선급금 비율)"
              value={formik.values.giPrePct}
              onChange={formik.handleChange}
              error={
                formik.touched.giPrePct && Boolean(formik.errors.giPrePct)
              }
              helperText={formik.touched.giPrePct && formik.errors.giPrePct}
            />
        </Grid>

        <Grid item xs={2}>
            <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="giCovPct"
              name="giCovPct"
              label="보증보험(계약이행 비율)"
              value={formik.values.giCovPct}
              onChange={formik.handleChange}
              error={
                formik.touched.giCovPct && Boolean(formik.errors.giCovPct)
              }
              helperText={formik.touched.giCovPct && formik.errors.giCovPct}
            />
        </Grid>

        <Grid item xs={2}>
            <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="giMtnPct"
              name="giMtnPct"
              label="보증보험(하자유지보수 비율)"
              value={formik.values.giMtnPct}
              onChange={formik.handleChange}
              error={
                formik.touched.giMtnPct && Boolean(formik.errors.giMtnPct)
              }
              helperText={formik.touched.giMtnPct && formik.errors.giMtnPct}
            />
        </Grid>

        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={6}>
            <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="collCondt"
              name="collCondt"
              label="수금조건"
              value={formik.values.collCondt}
              onChange={formik.handleChange}
              error={
                formik.touched.collCondt && Boolean(formik.errors.collCondt)
              }
              helperText={formik.touched.collCondt && formik.errors.collCondt}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="normal"
              variant="outlined"
              required={false}
              fullWidth
              id="payCondt"
              name="payCondt"
              label="지급조건"
              value={formik.values.payCondt}
              onChange={formik.handleChange}
              error={formik.touched.payCondt && Boolean(formik.errors.payCondt)}
              helperText={formik.touched.payCondt && formik.errors.payCondt}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{ py: 1 }}
        >
          {/* <Grid item xs={2}>
            <Typography variant="subtitle2" component="div" textAlign="center">
              참고사항
            </Typography>
          </Grid> */}
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="comment"
              name="comment"
              label="참고사항"
              multiline
              rows={3}
              value={formik.values.comment}
              onChange={formik.handleChange}
              error={formik.touched.comment && Boolean(formik.errors.comment)}
              helperText={formik.touched.comment && formik.errors.comment}
            />
          </Grid>
        </Grid>
      </Box>
      {/* <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          px: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Box sx={{ mr: 1 }}>
          <FileUploadIcon />
        </Box>
        <Typography variant="subtitle2">파일 업로드</Typography>
      </Box>
      <FormikProvider value={formik}>
        <FieldArray
          name="files"
          render={(arrayHelpers) => (
            <Box>
              <Box sx={{ my: 1 }}>
                {formik.values?.files.map((f, index) => {
                  return (
                    <OrderFileMultiFileForm
                      key={index}
                      file={f}
                      index={index}
                      touched={formik.touched}
                      errors={formik.errors}
                      handleChange={formik.handleChange}
                      handleBlur={formik.handleBlur}
                      handleRemove={() => arrayHelpers.remove(index)}
                    />
                  );
                })}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 2,
                  borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                }}
              >
                <Button
                  sx={{ mx: 2 }}
                  color="secondary"
                  variant="outlined"
                  onClick={() =>
                    arrayHelpers.push({ fileDesc: '', file: null })
                  }
                >
                  파일 추가
                </Button>
              </Box>
            </Box>
          )}
        ></FieldArray>
      </FormikProvider> */}
    </>
  );
};

export default OrderBookForm;
